interface Props {
  width?: number;
  height?: number;
  className?: string;
}

const ChevronDown = ({ width = 20, height = 20, className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={{ display: 'block' }}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M5 7.5 10 12.5 15 7.5"
    />
  </svg>
);

export default ChevronDown;
